import * as React from "react";
import { useNavigate } from "react-router";
import clsx from "clsx";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import { GreetingHeader } from "./components/GreetingHeader";
import { ChatInput } from "./components/ChatInput";

export const HomeView: React.FC = () => {
  const navigate = useNavigate();
  const userData = useAuthenticatedUser();
  const fullName = userData?.name && userData?.surname ? `${userData.name} ${userData.surname}` : userData?.email;
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleSendMessage = (message: string) => {
    navigate("/open-chat/", { state: { message } });
  };

  return (
    <div
      className={clsx(
        "flex min-h-[calc(100vh-8rem)] flex-1 flex-col items-center justify-center",
        "transition-opacity duration-1000",
        isVisible ? "opacity-100" : "opacity-0",
      )}
      style={{ marginTop: "-150px" }}
    >
      <div className="flex w-full max-w-4xl flex-col items-center justify-center px-8">
        <GreetingHeader fullName={fullName} />
        <ChatInput onSendMessage={handleSendMessage} />
      </div>
    </div>
  );
};
